import gql from 'graphql-tag';

export const verifySecureIdQuery = gql`
  query VerifySecureId($userId: UUID!, $secureId: UUID!) {
    verifySecureId(userId: $userId, secureId: $secureId)
  }
`;
